export const unregisterAllHotkeysAction = () => {
    if (!window.electronApi) {
        return;
    }

    window.electronApi.unregisterAllShortcuts();
};
